module.exports = __webpack_public_path__ + "img/augment.9eba7c01.svg";